var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { "text-align": "center", width: "100%" },
        attrs: { id: "text" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              "margin-left": "10%",
              "min-height": "800px",
              "padding-bottom": "30px",
              "background-color": "#fff"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "left",
                  width: "80%",
                  "margin-left": "10%"
                }
              },
              [
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "30px 0px 0px 20px"
                    }
                  },
                  [
                    _c("b", [
                      _vm._v("本次测试的项目场景为“"),
                      _c("span", { staticStyle: { color: "#4978F2" } }, [
                        _vm._v(_vm._s(_vm.randomScript.title))
                      ]),
                      _vm._v("”，请尽快熟悉以下资料并了解测试要求：")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.randomScript.intro))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { "font-size": "14px" },
                      domProps: { innerHTML: _vm._s(_vm.randomScript.script) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { "font-size": "14px" },
                      domProps: { innerHTML: _vm._s(_vm.randomScript.asking) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      margin: "20px 0px 0px 20px",
                      padding: "10px 20px 10px 20px",
                      "text-align": "center"
                    }
                  },
                  [
                    _vm.seconds > 0
                      ? _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "38%",
                                width: "80px"
                              }
                            },
                            [_vm._v("测试将在")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                width: "100px",
                                height: "30px",
                                "border-radius": "6px",
                                "background-color": "#AAA",
                                "padding-top": "2px",
                                margin: "0px 5px 0px 5px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.time))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v("后开始")
                          ])
                        ])
                      : _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "38%",
                                width: "80px"
                              }
                            },
                            [_vm._v(" ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "font-size": "15px",
                                width: "100px",
                                height: "30px",
                                "border-radius": "6px",
                                "background-color": "#69f",
                                color: "#f7f7f7",
                                "padding-top": "2px",
                                margin: "0px 5px 0px 5px"
                              },
                              on: { click: _vm.goKaohe }
                            },
                            [_vm._v("开始测试")]
                          )
                        ])
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("项目介绍")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("参考话术")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("测试要求")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aaaada3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaaada3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/CallOutRandomScript.vue
// module id = 1648
// module chunks = 0